import axios from "axios";
import { localStorageRemoveItem } from "./globalFunctions";
import { getCookie } from "../context/useCookies";

const isLive = true;

export const apiUrl = isLive
  ? "https://portal.eyision.com/api/v1/"
  : "http://localhost:8080/api/v1/";
export const socketApiUrl = isLive
  ? "https://portal.eyision.com/socket"
  : "http://localhost:8080/socket";

// export const apiUrl = isLive
//   ? "https://dev-eyision.jamsara.com/api/v1/"
//   : "http://localhost:8080/api/v1/";
// export const socketApiUrl = isLive
//   ? "https://dev-eyision.jamsara.com/socket"
//   : "http://localhost:8080/socket";

export const stripePublicKey = isLive
  ? "pk_live_51QZYrcCuzyoAJYXgLRDVc2GOQxdc8yUk46871ZhRVfmaVEvl84v1sjEKYtCn17CwRWbLVdw5yAobtmdYy9i6avi4004tfmna0b"
  : "pk_test_51R8L6pHDxFm8flG5wXLDNZ0sPNYfCmeUgmFsCyy6QxN6oFhFfT4DhPMBd6c1UpceGQissSbznkZjSUhtDdKwhkcz00OFVinEqT";

const axiosPublic = axios.create({
  baseURL: apiUrl,
  headers: { "Content-Type": "application/json" },
});

const axiosPrivate = axios.create({
  baseURL: apiUrl,
  headers: { "Content-Type": "application/json" },
});

const axiosImage = axios.create({
  baseURL: apiUrl,
  headers: { "Content-Type": "multipart/form-data" },
});

const authRequestInterceptor = (config) => {
  const token = getCookie("accessToken")?.replace(/^"|"$/g, "");

  if (!token) {
    localStorageRemoveItem();
    throw new axios.Cancel("Missing authentication token");
  }

  config.headers.Authorization = `Bearer ${token}`;
  return config;
};

const errorResponseInterceptor = (error) => {
  if (!error.response) {
    return Promise.reject({ message: "Network error. Please try again." });
  }

  switch (error.response.status) {
    case 403:
      return Promise.reject({
        message:
          error.response.data?.message ||
          "Access denied. Insufficient permissions.",
      });
    case 500:
      return Promise.reject({
        message: "Internal server error. Please try again later.",
      });
    default:
      return Promise.reject(
        error.response.data || { message: "An unknown error occurred" }
      );
  }
};

[axiosPrivate, axiosImage].forEach((instance) => {
  instance.interceptors.request.use(authRequestInterceptor);
  instance.interceptors.response.use((response) => {
    if (response?.data?.code === 3) {
      localStorageRemoveItem();
      return Promise.reject({ message: "Session expired" });
    }
    return response;
  }, errorResponseInterceptor);
});

axiosPublic.interceptors.response.use(
  (response) => response,
  errorResponseInterceptor
);

const uploadImageDirect = async (apiPath, formData) => {
  try {
    const response = await axiosImage.post(apiPath, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export { axiosPrivate, axiosPublic, axiosImage, uploadImageDirect };
